import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * SearchBoxComponent
 * A component that provides a search box with a toggle feature.
 * It emits the search value when the user types in the search box.
 * The search box can be toggled to show or hide.
 */
@Component({
	selector: 'app-filter-box',
	templateUrl: './filter-box.component.html',
	styleUrls: ['./filter-box.component.scss']
})
export class FilterBoxComponent {

	/** Placeholder text for the Caption */
	@Input() Caption: string = '';

	/** Placeholder text for the search box */
	@Input() PlaceHolder: string = 'Search...';

	/** Icon to display in the search box */
	@Output() search = new EventEmitter<string>();

	/** Search value */
	protected searchValue: string = '';

	/** Visibility of the search box */
	protected searchVisible = false;

	/**
	 * toggleSearch
	 */
	toggleSearch() {
		this.searchVisible = !this.searchVisible;
	}

	/**
	 * onSearch
	 * @param event KeyboardEvent
	 */
	onSearch(event: KeyboardEvent): void {
		const input = event.target as HTMLInputElement;
		this.searchValue = input.value.trim();
		this.search.emit(this.searchValue);
	}

	/**
	 * clearSearch
	 * Clears the search input and emits an empty string.
	 */
	clearSearch() {
		this.searchValue = '';
		this.search.emit(this.searchValue);
	}

}
